<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('settings.settingsLabel') }}</span>
        <h3 class="page-title">{{ $t('settings.transaltion.editTranslation') }}</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/ustawienia/slowniki-wielojezycznosci')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          {{ $t('ui.backToList') }}
        </d-button>
        <d-button theme="success" @click.prevent="validateForm">{{ $t('ui.saveChanges') }}</d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab
            :title="$t('ui.generalInfo')"
            active>
            <h4 class="mb-3 pb-3 border-bottom">
              {{ $t('ui.generalInfo') }}
            </h4>

            <validation-observer
              ref="translation-edit-form"
              tag="form">
              <template v-if="allDataLoaded">
                <div
                  v-for="(language, index) of languages"
                  :key="'language-field-' + index"
                  class="form-group">
                  <validation-provider
                    rules="required_always"
                    :name="'translation-values-' + language.id"
                    v-slot="{ errors }">
                    <label
                      for="name"
                      :data-state="errors.length ? 'invalid' : null">
                      {{ $t('ui.language') }} {{ language.name }}:
                    </label>

                    <wysiwyg-editor
                      v-if="with_editor"
                      v-model="translationValues[language.id]"
                      :key="'tinymce-editor-' + index" />
                    <d-textarea
                      v-else
                      :state="errors.length ? 'invalid' : null"
                      v-model="translationValues[language.id]"
                      :value.prop="translationValues[language.id]"
                      rows="3" />
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </div>
              </template>
            </validation-observer>

            <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center overlay-loading">
              {{ $t('ui.dataLoading') }}&hellip;
            </div>

            <d-alert
              v-if="loadError"
              show
              theme="warning">
              {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
            </d-alert>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import OrderWysiwyg from './../orders/OrderWysiwyg.vue';

export default {
  name: 'translation-edit',
  components: {
    'wysiwyg-editor': OrderWysiwyg
  },
  computed: {
    allDataLoaded () {
      return this.loaded && this.loadedLanguages;
    }
  },
  data() {
    return {
      id: 0,
      value: '',
      translation: '',
      translations: [],
      with_editor: false,
      languages: [],
      loaded: false,
      loadedLanguages: false,
      loadError: false,
      translationValues: {}
    };
  },
  mounted () {
    FormUtils.loadItemData(this, {
      method: 'get',
      endpointBase: '/translations/item/',
      instanceFields: ['value', 'translations', 'with_editor'],
      loadedKey: 'loaded',
      errorKey: 'loadError',
      successAction: () => {
        let languageIds = this.translations.map(item => item.language_id);

        for (let i = 0; i < languageIds.length; i++) {
          let languageID = languageIds[i];
          this.translationValues[languageID] = this.translations.filter(item => item.language_id === languageID)[0].translation;
        }

        this.languages.sort((itemA, itemB) => itemA.id - itemB.id);
      }
    });

    this.loadAdditionalData();
  },
  methods: {
    validateForm () {
      FormUtils.validate(this.$refs['translation-edit-form'], this.submitForm);
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: '/languages/items',
        loadedKey: 'loadedLanguages',
        outputKey: 'languages',
        errorKey: 'loadError'
      });
    },
    submitForm () {
      FormUtils.submit({
        $http: this.$http,
        endpoint: '/translations/update/' + this.id,
        formData: {
          id: this.id,
          translations: this.translationValues
        },
        successTitle: this.$t('settings.transaltion.translationEditSuccessTitle'),
        successText: this.$t('settings.transaltion.translationEditSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('settings.transaltion.translationEditErrorText'),
        successAction: () => {
          this.$router.push('/ustawienia/slowniki-wielojezycznosci')
        }
      });
    }
  }
};
</script>

<style lang="scss">
label[data-state="invalid"] {
  color: red;
}

label[data-state="invalid"] ~ div > .tox-tinymce {
  border-color: red!important;
}
</style>
